<template>
  <carousel
    :per-page="1"
    :pagination-padding="4"
    :value="selectedPage"
    :pagination-enabled="true"
    pagination-active-color="#4c7499"
    @pageChange="handlePageChange"
  >
    <slide
      v-for="testimonial in testimonials"
      :key="testimonial.Id"
    >
      <client-testimonial :testimonial="testimonial" />
    </slide>
  </carousel>
</template>

<script>
import ClientTestimonial from './ClientTestimonial.vue'
import { Carousel, Slide } from '@Shared/components/VueCarousel'

export default {
  name: 'ClientTestimonialCarousel',
  components: {
    Carousel,
    ClientTestimonial,
    Slide
  },
  props: {
    testimonials: { type: Array, default: function () { return [] }, required: true }
  },
  data () {
    return {
      selectedPage: 1
    }
  },
  methods: {
    handlePageChange () {
      console.log('handlePageChange')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentItems/ClientTestimonialCarousel.vue